import { Injectable, Pipe } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {
  private apiUrl = environment.apiUrl;
  userDetails = JSON.parse(localStorage.getItem('LoginData'));
  constructor(private http: HttpClient) { }


  // post api call function
  postApi(url: string, data: object): any {
    return this.http.post(this.apiUrl + url, data).pipe(
      catchError(
        (error: HttpErrorResponse) => throwError(error)
      )
    );
  }
  getApi(url: string, data: object): any {
    return this.http.get(this.apiUrl + url).pipe(
      catchError(
        (error: HttpErrorResponse) => throwError(error)
      )
    );
  }
  getToken(): any {
    if (localStorage.getItem('LoginData')) {
      const data = JSON.parse(localStorage.getItem('LoginData'));
      return data.token;
    }
  }
  goToLogin(): any {
    const token = '';
    return token;
  }
  removeClass(): any {
    document.getElementById('preloader').classList.add('hide');
    // document.getElementById('spin').classList.remove('cm-spinner');
  }
  addClass(): any {
    document.getElementById('preloader').classList.remove('hide');
    // document.getElementById('spin').classList.add('cm-spinner');
  }
}
